import { Component , OnInit } from '@angular/core';
import { GtmAutoService } from './core/providers/analytics/gtm.service';
import { KeycloakService } from 'keycloak-angular';
import { LogService } from './core/errors/log.service';
import { ConsoleUtils } from './core/init/console.utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ConsoleUtils]
})
export class AppComponent {
  titulo = 'pua-app';
  /**
   * @description constructor
   * @params gtmService
   * @params keycloack
   * @params logService
   */
  constructor(
    public gtmService: GtmAutoService,
    private keycloack: KeycloakService,
    private logService: LogService) {
    this.gtmService = gtmService;
    this.gtmService.init();
    this.keycloack = keycloack;
    this.logService = logService;
  }

  /**
   * @description login
   */
  login(): void {
    this.keycloack.login();
  }
  /**
   * @description logout
   */
  logout(): void {
    this.keycloack.logout('http://localhost:4200');
  }
  /**
   * @description traza error
   */
  traceError(): void {
    this.logService.traceError('Mensaje de prueba de error');
  }
}
